module.exports = __webpack_public_path__ + "cf22f2a99541701870356f370199e49c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/mummy-hand-s.png
// module id = 2562
// module chunks = 0